import Video from "../assets/video.mp4";

const SectionOne = () => {
  return (
    <div className="relative w-full h-[50vh] md:h-screen overflow-hidden">
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        src={Video}
        autoPlay
        loop
        muted
        playsInline
      />
      <div className="absolute top-0 left-0 w-full h-full bg-[#533144]/70"></div>
      <div className="relative z-10 h-full w-full text-white px-6 md:px-20 text-left flex flex-col items-center justify-center gap-3">
        <h1 className="text-4xl md:text-6xl font-bold leading-tight">
          ESTRATEGIAS CORPORATIVAS
        </h1>
        <h1 className="text-4xl md:text-6xl font-bold leading-tight">
          DE ALTO NIVEL
        </h1>
        <p className="text-base md:text-lg">
          Somos líder en la consultoría administrativa, jurídica y contable.
        </p>
      </div>
    </div>
  );
};

export default SectionOne;
